<era-apple-device-ui [device]="device$ | async"
                     (applicationLockChange)="applicationLockChanged($event)"></era-apple-device-ui>